import { RecipesCollectionRef } from 'services/firebase';

import RecipesMapper from 'services/mappers/recipes/RecipeMapper';

const RECIPES_PER_LIST = 4;

const listLatest = async (lastRecipeID) => {
  const _fetchLastRecipeDataModel = async () => {
    if (!lastRecipeID) return null;

    return await RecipesCollectionRef().doc(lastRecipeID).get();
  };
  const lastRecipeDataModel = await _fetchLastRecipeDataModel();

  const _fetchRecipes = async () => {
    if (!lastRecipeDataModel)
      return await RecipesCollectionRef()
        .orderBy('createdAt', 'desc')
        .limit(RECIPES_PER_LIST)
        .get();

    return await RecipesCollectionRef()
      .orderBy('createdAt', 'desc')
      .startAfter(lastRecipeDataModel)
      .limit(RECIPES_PER_LIST)
      .get();
  };

  const querySnapshot = await _fetchRecipes();

  const recipeModels = querySnapshot.docs.map((doc) =>
    RecipesMapper.mapFirebaseRefToModel(doc.id, doc.data())
  );

  return recipeModels;
};

export default listLatest;
